// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sanity-cta[data-v-3064e654] {\n  margin-bottom: 0.5rem;\n  width: 100%;\n}\n@media (min-width: 600px) {\n.sanity-cta[data-v-3064e654] {\n    margin-bottom: 0;\n    margin-right: 0.5rem;\n    width: auto;\n}\n}\n.border-white[data-v-3064e654] {\n  border: 1px solid #fff;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
